import { ORDER_CART } from '../actionTypes';

const initialState = {
    arrOrderCart: [],
    orderCartName: '',
    objSelectedCartRowData: {},
    bIsCartSaved: false,
    arrOrderEntryGridData: [],
    bIsOrderCartConfirmApiPending: false,
    objCartForGoBack: {},
    orderCartMargin: 0,
    arrOrderCartScrips : [],
    placeOrderCartOrderSuccess : {},
    arrOrderDataBackupVertical : [],
    arrOrdersMarketPrice : []
};
// BT-106965_27_02_2024_SrikanthRao_ordercart

const orderCartReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case ORDER_CART?.UPDATE_ORDER_CART_MARGIN: {
            return {
                ...state,
                orderCartMargin: actions?.payload
            };
        }
        case ORDER_CART.GET_ORDER_CART_SUCCES: {
            return {
                ...state,
                arrOrderCart: actions.payload
            };
        }
        case ORDER_CART.GET_ORDER_CART_FAIL: {
            return {
                ...state,
                arrOrderCart: actions.payload
            };
        }
        case ORDER_CART.UPDATE_ORDER_CART_SELECTED_ROW: {
            return {
                ...state,
                objSelectedCartRowData: actions.payload
            };
        }
        case ORDER_CART.CART_SAVED_SUCCESS: {
            return {
                ...state,
                bIsCartSaved: actions.payload
            };
        }
        case ORDER_CART.ORDERENTRY_GRID_DATA: {
            return {
                ...state,
                arrOrderEntryGridData: actions.payload
            };
        }
        case ORDER_CART.ORDERENTRY_CART_API_PENDING: {
            return {
                ...state,
                bIsOrderCartConfirmApiPending: actions.payload
            };
        }
        case ORDER_CART.CART_SAVED_GOBACK: {
            return {
                ...state,
                objCartForGoBack: actions.payload
            };
        }
         //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes  - Start
        case ORDER_CART.GET_ORDER_CART_SCRIPS : {
            return {
                ...state,
                arrOrderCartScrips : actions.payload
            }
        }
        case ORDER_CART.PLACE_ORDERCART_ORDER_SUCCESS : {
           return { ...state,
            placeOrderCartOrderSuccess : actions.payload
           }
        }
        case ORDER_CART.GET_ORDER_CART_BACKUP_VERTICAL : {
            return {
                ...state,
                arrOrderDataBackupVertical : actions.payload
            }
        }
        case ORDER_CART.GET_ORDER_MARKET_PRICE : {
            return {
                ...state,
                arrOrdersMarketPrice : actions.payload
            }
        }
         //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes  - End
        default:
            return state;
    }

};

export default orderCartReducer;
